module.exports = __webpack_public_path__ + "static/media/bronze-crown.2f107e96.svg";